module.exports = __webpack_public_path__ + "img/rule5.81cc6bee.jpg";